import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PpeService {

  private URL = environment.api + "api/erp/propertyEquipment";
  
  constructor(private http: HttpClient) { }

  getTemporalItems(){
    return this.http.get(this.URL + "/temp");
  }

  getDepreciations(){
    return this.http.get(this.URL + "/depreciations");
  }

  getSavedItems(){
    return this.http.get(this.URL + "/items");
  }

  updateTempDepreciation(idTemp,request){
    return this.http.post(this.URL + `/temporal/single/${idTemp}`, request);
  }

  saveTempsDepreciation(){
    return this.http.post(this.URL + `/temp/persist`, null);
  }

  registerDepreciation(date){
    return this.http.post(this.URL + `/register`, date);
  }

  createTempDepreciation(newRegister){
    return this.http.post(this.URL + `/temp`, newRegister);
  }

  deletePpeItem(ppeId){
    return this.http.delete(this.URL + `/temp/${ppeId}`);
  }

}
